import { render } from "./Li-Divider.vue?vue&type=template&id=b360c4a8"
import script from "./Li-Divider.vue?vue&type=script&lang=js"
export * from "./Li-Divider.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__